define(['lodash'], function(_) {
  return function mod(args) {
    return _(args)
      .filter(function(d) {
        try {
          return d && (('name' in d && 'requires' in d) || _.keys(d) === ['name']);
        } catch(e) {
          return false;
        }
      })
      .map('name')
      .value();
  };
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/mod.js
 **/